import React, { useState, useEffect } from 'react';
import { retailersAPI } from '../services/api';
import './AgentPages.css';

const AllRetailersPage = () => {
  const [retailers, setRetailers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRetailers();
  }, []);

  const fetchRetailers = async () => {
    try {
      setLoading(true);
      setError(null);
      const resp = await retailersAPI.list();
      const list = Array.isArray(resp) ? resp : (resp?.data || resp?.retailers || []);
      setRetailers(list);
    } catch (err) {
      setError(err.message || 'Failed to load retailers');
      setRetailers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this retailer? This action cannot be undone.')) return;
    try {
      setLoading(true);
      setError(null);
      await retailersAPI.delete(id);
      // remove from list
      setRetailers(prev => prev.filter(r => r.id !== id));
    } catch (err) {
      setError(err.message || 'Failed to delete retailer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>All Retailers</h1>
        <p>List of retailers assigned to you</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="loader">Loading...</div>
      ) : retailers.length === 0 ? (
        <div className="no-data">No retailers found</div>
      ) : (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                <th>Shop</th>
                <th>Owner</th>
                <th>Phone</th>
                <th>Email</th>
                <th>PAN</th>
                <th>Aadhaar</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {retailers.map((r) => (
                <tr key={r.id}>
                  <td>{r.shop_name || r.shopName || r.name}</td>
                  <td>{r.name}</td>
                  <td>{r.phone}</td>
                  <td>{r.email || 'N/A'}</td>
                  <td>{r.pan_number || r.panNumber || '-'}</td>
                  <td>{r.aadhaar_number || r.aadhaarNumber || '-'}</td>
                  <td>
                    <button className="button button-danger" onClick={() => handleDelete(r.id)} disabled={loading}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AllRetailersPage;
